// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__yhHsm","contentWrapper":"styles_contentWrapper__TKRpQ"};